import React from 'react';
export default function AviatorGoggsSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="16" width="14" height="10" rx="5" fill="#8D6E63" stroke="#5D4037" strokeWidth="1.5" />
      <rect x="22" y="16" width="14" height="10" rx="5" fill="#8D6E63" stroke="#5D4037" strokeWidth="1.5" />
      <rect x="18" y="19" width="4" height="3" rx="1" fill="#5D4037" />
      <ellipse cx="11" cy="21" rx="4" ry="3" fill="#81D4FA" opacity="0.5" />
      <ellipse cx="29" cy="21" rx="4" ry="3" fill="#81D4FA" opacity="0.5" />
    </svg>
  );
}
